import { makeStyles } from '@material-ui/core';
import Loading from 'components/Loading';
import { urlPayphoneButton } from 'constants/urls';
import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getCreditItem } from 'redux/actions/aClientes';
import paymentStyle from 'assets/jss/payment/paymentStyle';

const useStyles = makeStyles(paymentStyle);

export const CreditsPayment = () => {

  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  let { creditsItemId, clientId } = useParams();

  // Consultar datos de credito item seleccionado por el usuario
  const loadCreditItem = useCallback(
    async () => {
      try {

        const { data } = await dispatch(getCreditItem(creditsItemId));
        const { creditItem: item, empresa, dataEncrypted, transactionType } = data;
        const { pp_identifier: appId, pp_token: token } = empresa;
        setLoading(false);

        const searchParams = new URLSearchParams({ dataEncrypted, clientId, transactionType });

        //Cargar script payphone
        loadScript(`${urlPayphoneButton}${appId}`).then(() => {

          const scriptPPButtons = document.createElement("script");
          scriptPPButtons.type = 'text/javascript';
          scriptPPButtons.id = "scriptPayphone";

          const currentTime = new Date().getTime();
          const clientTransactionId = `${currentTime}.${clientId}`;

          const pagoInfo = `http:localhost:3000/confirmarTransaccion/123/abc?${searchParams.toString()}`
          console.log({ pagoInfo })

          scriptPPButtons.innerHTML = `
            const loadFormScript = function() {
              payphone.Button({
              
                //token obtenido desde la consola de developer
                token: '${token}',
                
                //PARÁMETROS DE CONFIGURACIÓN
                btnHorizontal: true,
                btnCard: true,
                
                createOrder: function(actions){
                
                  //Se ingresan los datos de la transaccion ej. monto, impuestos, etc
                  return actions.prepare({
                  
                    amount: ${item.precio_pp},
                    amountWithoutTax: ${item.precio_pp},
                    currency: "USD",
                    clientTransactionId: '${clientTransactionId}',
                    lang:"es",
                  }).then(function(paramlog){
                    console.log(paramlog);
                    return paramlog;
                  }).catch(function(paramlog2){
                      console.log(paramlog2);
                      return paramlog2;
                  });
                
                },
                onComplete: function(model, actions){
                
                  //Se confirma el pago realizado
                  actions.confirm({
                    id: model.id,
                    clientTxId: model.clientTxId
                  }).then(function(value){
                  
                    //EN ESTA SECCIÓN SE RECIBE LA RESPUESTA Y SE MUESTRA AL USUARIO
                    
                    if (value.transactionStatus == "Approved"){
                      console.log("Pago " + value.transactionId + " recibido, estado " + value.transactionStatus );
                      console.log(value)
                      window.location.href = '/confirmarTransaccion/' + value.transactionId  + '/' + value.clientTransactionId + '?${searchParams.toString()}' ;
                    }
                  }).catch(function(err){
                    console.log(err);
                  });
              
              }
              }).render("#pp-button");
              
            }
            loadFormScript();
          `;

          document.body.appendChild(scriptPPButtons);
        });

      } catch (error) {
        console.log(error)
      }
    },
    [dispatch, creditsItemId, clientId],
  )

  const loadScript = (url) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url
      script.id = "scriptClienteId"

      document.body.appendChild(script);

      const onLoadScript = () => resolve(script);

      const onErrorScript = () => reject(new Error(`${url} failed to load.`));

      // Resolve the promise once the script is loaded
      script.addEventListener('load', onLoadScript, { once: true })

      // Catch any errors while loading the script
      script.addEventListener('error', onErrorScript, { once: true })
    })
  }

  useEffect(() => {
    loadCreditItem();

    return () => {
      // Eliminar scripts al salir página
      let script = document.getElementById("scriptClienteId");
      script.remove();

      let script2 = document.getElementById("scriptPayphone");
      script2.remove();
    }
  }, [loadCreditItem])


  return (
    <div className={classes.mainContainer}>
      <Loading title="Cargando..." loading={loading}>
        <>
          {/*  Botón de pago payphone */}
          <div id='pp-button' className={classes.paymentContainer}></div>
        </>
      </Loading>
    </div>
  );
}
